<template>
  <svg :viewBox="`${this.left} -${this.bottom} ${this.width} ${this.height}`">
    <g :style="`transform-origin: 50% -50%; transform: scale(${scale})`">
      <g :transform="`scale(1,-1) translate(0,${this.ship.particulars.B+this.margin})`">
        <path
          :d="scaleXZpath('M -4.2829904,6.6909873 C 16.933854,3.4804663 19.361169,-0.0275615 35.349527,0')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />


        <path
          :d="scaleXZpath('M -4.2829904,6.6909873 C 16.933854,3.4804663 19.361169,-0.0275615 35.349527,0')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 200,6.6909873 208.72602,19.295336')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 192.14801,-5.3e-6 C 196.41419,-5.3e-6 202.77645,0.0717348 205.65298,1.8831738 206.63867,2.5038938 207.59526,3.8447797 207.29207,4.9694835 207.05803,5.8376986 205.81742,6.5006999 205.00074,6.3932021 203.88971,6.2469598 200.00114,5.777509 200,6.6909873')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 180.62143,34.707616 160.16744,34.707621')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M -1.6394195,0.2577383 H 1.1381547')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 35.349539,0 H 4.6441336')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 1.1381547,0.2577383 1.8836196,5.6846851')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 191.50822,31.656583 190.24383,27.784401')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M -2.0963164,5.0017187 -1.6394195,0.2577383')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M -4.2829904,6.6909873 H 200')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 1.8836196,5.6846851 4.6441336,0')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 190.24383,27.784401 196.19743,19.68683')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 160.16744,34.707621 160.16762,30.835439')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 6.939537,30.835439 -4.2829904,13.796617 V 6.6909873')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 6.939537,30.835439 H 160.16762')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M -2.0963164,5.0017187 -4.2829904,6.6909873')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 196.19743,19.68683 208.72602,19.295336')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="scaleXZpath('M 35.349539,0 192.14801,-5.3e-6')"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
          :d="scaleXZpath('M 180.62143,34.707616 191.50822,31.656583')"
        />
      </g>

      <g :transform="`scale(1,-1) translate(0,${0.5*this.ship.particulars.B})`">
        <path
          :d="`M ${scaleXY(-4.7,14)} C ${scaleXY(0,14.5)} ${scaleXY(10,16)} ${scaleXY(30,16)}`"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(30,16)} L ${scaleXY(175,16)}` "
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(209,0)} C ${scaleXY(209,10)} ${scaleXY(185,16)} ${scaleXY(175,16)}`"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(-4.7,-14)} C ${scaleXY(0,-14.5)} ${scaleXY(10,-16)} ${scaleXY(30,-16)}`"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(30,-16)} L ${scaleXY(175,-16)}` "
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(209,0)} C ${scaleXY(209,-10)} ${scaleXY(185,-16)} ${scaleXY(175,-16)}`"
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(-4.7,14)} L ${scaleXY(-4.7,-14)}` "
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(160,16)} L ${scaleXY(160,-16)} Z` "
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
        <path
          :d="`M ${scaleXY(191.5,13)} L ${scaleXY(191.5,-13)} Z` "
          :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      </g>

      <ShipFlettners
        v-if="rotors"
        :ship="ship"
        :rotors="rotors"
        :margin="margin"
        :xPositions="xPositions"
        :scaleX="scaleX"
        :scaleY="scaleY"
        :scaleZ="scaleZ"
        :scaleXY="scaleXY"
        :scaleXZ="scaleXZ"
        :lppScale="lppScale"
        @onToggleRotor="toggleRotor"
      />
    </g>
  </svg>
</template>

<script>
import ShipFlettners from "./ShipFlettners";

export default {
  name: "ShipPax",
  data: function() {
    return {
      Lpp: 200.0,
      Lwl: 204.0,
      Loa: 213.0,
      B: 32,
      T: 7.0,
      D: 31.0,
      relMargin: 0.025,
      xPositions: [20, 60, 100, 140]
    };
  },
  components: {
    ShipFlettners
  },
  props: {
    ship: Object,
    rotors: Object,
    withRotors: Boolean,
    scale: Number
  },
  methods: {
    scaleXZpath: function(path) {
      const tok = path.split(" ");
      path = "";
      const isAlpha = /^[A-Z]+$/;
      for (let i = 0; i < tok.length; i++) {
        if (isAlpha.test(tok[i])) {
          path += " " + tok[i];
        } else {
          var coord = tok[i].split(",").map(parseFloat);
          if (coord.length == 2) {
            path += " " + this.scaleXZ(coord[0], coord[1]);
          } else {
            if (tok[i - 1] === "H") {
              path += " " + this.scaleX(coord[0]);
            } else {
              path += " " + this.scaleZ(coord[0]);
            }
          }

          //             path = path.substr(0,path.length-2)+ " L"
          //   path += " " + this.scaleXZ(prevCoord[0]+coord[0],prevCoord[1])
          //   prevCoord = [prevCoord[0]+coord[0],prevCoord[1]]
          // }
          // else {
          //   path = path.substr(0,path.length-2)+ " L"
          //   path += " " + this.scaleXZ(prevCoord[0],prevCoord[1]+coord[0])
          //   prevCoord = [prevCoord[0],prevCoord[1]+coord[0]]
        }
      }
      return path.substr(1);
    },
    scaleXY: function(x, y) {
      return this.scaleX(x) + "," + this.scaleY(y);
    },
    scaleXZ: function(x, z) {
      return this.scaleX(x) + "," + this.scaleZ(z);
    },
    scaleX: function(x) {
      if (x > 0.0 && x < this.Lpp) {
        return (x / this.Lpp) * this.ship.particulars.Lpp;
      } else if (x >= this.Lpp) {
        const Lfwd = this.ship.particulars.Loa - this.ship.particulars.Lwl;
        const refLwfd = this.Loa - this.Lwl;
        return this.ship.particulars.Lpp + ((x - this.Lpp) / refLwfd) * Lfwd;
      } else {
        const Laft = this.ship.particulars.Lwl - this.ship.particulars.Lpp;
        const refLaft = this.Lwl - this.Lpp;
        return (x / refLaft) * Laft;
      }
    },
    scaleY: function(y) {
      return (y / this.B) * this.ship.particulars.B;
    },
    scaleZ: function(z) {
      if (z <= this.T) {
        return (z / this.T) * this.ship.particulars.T;
      } else if (z < this.D) {
        return (
          this.ship.particulars.T +
          ((z - this.T) / (this.D - this.T)) *
            (this.ship.particulars.D - this.ship.particulars.T)
        );
      } else {
        return (
          this.ship.particulars.D +
          ((z - this.D) / this.Lpp) * this.ship.particulars.Lpp
        );
      }
    },
    toggleRotor: function(rotor) {
      this.$emit("toggleRotor", rotor);
    }
  },
  computed: {
    lppScale: function() {
      return this.ship.particulars.Lpp / 200.0;
    },
    margin: function() {
      return this.ship.particulars.Loa * this.relMargin;
    },
    shipHeight: function() {
      if (!this.rotors) {
        return this.scaleZ(35.0);
      }
      return Math.max(
        this.scaleZ(35.0),
        this.ship.particulars.D + this.rotors.h
      );
    },
    bottom: function() {
      return this.shipHeight + 2 * this.margin + this.ship.particulars.B;
    },
    height: function() {
      return this.shipHeight + 3 * this.margin + this.ship.particulars.B;
    },
    width: function() {
      return this.ship.particulars.Loa + 2 * this.margin;
    },
    left: function() {
      return (
        this.ship.particulars.Lpp - this.ship.particulars.Lwl - this.margin
      );
    },
    sideRotorDist: function() {
      return 0.5 * this.ship.particulars.B - 1.2 * this.rotors.D;
    }
  }
  // mounted() {
  //   this.$nextTick(function() {
  //     this.onResize(null);
  //       window.addEventListener('resize', this.onResize);
  //   })
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.onResize);
  // }
};
</script>

<style scoped>
/* svg path {
  shape-rendering: optimizeSpeed ;
} */
</style>